module.exports = __webpack_public_path__ + "img/mentor2.fda6b90.jpg";